import { Pipe, PipeTransform } from '@angular/core';
import { PageTypes } from '@features/page/page.config';
import { SearchResultCmsPageViewModel } from '@models/api.models';

const getTranslationKey = (pageType: string) => {
    switch (pageType) {
        case PageTypes.ArticlePage:
        case PageTypes.BrandPage:
        case PageTypes.ProductDetailPage:
        case PageTypes.RecipePage:
            return pageType;
    }
    return PageTypes.StandardPage;
};

@Pipe({
    name: 'groupByPageType',
    standalone: true
})
export class GroupByPageTypePipe implements PipeTransform {
    transform(values: SearchResultCmsPageViewModel[]): { [key: string]: SearchResultCmsPageViewModel[] } {
        const links: { [key: string]: SearchResultCmsPageViewModel[] } = {};
        values.forEach(link => {
            const groupKey = getTranslationKey(link.contentType || '');
            if (links[groupKey]) {
                links[groupKey].push(link);
            } else {
                links[groupKey] = [link];
            }
        });
        return links;
    }
}
